<script>
  import AffordabilityCalculatorIcon from './icons/AffordabilityCalculatorIcon.svelte';
  import IncomeRequiredCalculatorIcon from './icons/IncomeRequiredCalculatorIcon.svelte';
  import MortgagePaymentCalculatorIcon from './icons/MortgagePaymentCalculatorIcon.svelte';
  import RefinanceSavingsCalculatorIcon from './icons/RefinanceSavingsCalculatorIcon.svelte';
  import ReverseMortgageCalculatorIcon from './icons/ReverseCalculatorIcon.svelte';

  export let grayIcons;
  export let activeCalculatorString;
  // note that keyboard events need an intermediary to detect key, mouse events don't
  export let setActiveCalculator;
</script>

<div class="py-6 lg:py-12">
  <h2 class="text-21 text-center font-medium md:text-25 lg:text-26">
    Select a Calculator
  </h2>
  <div class="flex flex-wrap items-center justify-between pt-8 lg:pb-12">
    <div
      class="{activeCalculatorString === 'MortgagePaymentCalculator' ? 'selected ' : ''}calculator-select-item
      flex flex-col items-center border-t border-r border-l border-gray-eighty
      py-10 w-1/2 cursor-pointer lg:border-t-0 lg:border-l-0 lg:w-1/5"
      on:click={() => setActiveCalculator('MortgagePaymentCalculator')}
      on:keydown={e => setActiveCalculator('MortgagePaymentCalculator', e)}
      tabindex="0">
      <div class="h-32 lg:h-40">
        <MortgagePaymentCalculatorIcon {grayIcons} />
      </div>
      <div class="h-24 flex items-center px-10 lg:h-40 lg:px-0">
        <p
          class="text-21 text-center font-medium mt-8 md:text-23 lg:font-light">
          Mortgage Payment
        </p>
      </div>
    </div>
    <div
      class="{activeCalculatorString === 'IncomeRequiredCalculator' ? 'selected ' : ''}calculator-select-item
      flex flex-col items-center border-t border-r border-gray-eighty py-10
      w-1/2 cursor-pointer lg:border-t-0 lg:w-1/5"
      on:click={() => setActiveCalculator('IncomeRequiredCalculator')}
      on:keydown={e => setActiveCalculator('IncomeRequiredCalculator', e)}
      tabindex="0">
      <div class="h-32 lg:h-40">
        <IncomeRequiredCalculatorIcon {grayIcons} />
      </div>
      <div class="h-24 flex items-center px-10 lg:h-40 lg:px-0">
        <p
          class="text-21 text-center font-medium mt-8 md:text-23 lg:font-light
          lg:mt-8 lg:px-20">
          Income Required
        </p>
      </div>
    </div>
    <div
      class="{activeCalculatorString === 'AffordabilityCalculator' ? 'selected ' : ''}calculator-select-item
      flex flex-col items-center self-start border-t border-r border-b border-l
      border-gray-eighty py-10 w-1/2 cursor-pointer lg:border-t-0 lg:border-r-0
      lg:border-b-0 lg:border-l-0 lg:w-1/5"
      on:click={() => setActiveCalculator('AffordabilityCalculator')}
      on:keydown={e => setActiveCalculator('AffordabilityCalculator', e)}
      tabindex="0">
      <div class="h-32 lg:h-40">
        <AffordabilityCalculatorIcon {grayIcons} />
      </div>
      <div class="h-24 flex items-center px-10 lg:h-40 lg:px-0">
        <p
          class="text-21 text-center font-medium mt-8 md:text-23 lg:font-light
          lg:mt-8 lg:px-20">
          Affordability
        </p>
      </div>
    </div>
    <div
      class="{activeCalculatorString === 'RefinanceSavingsCalculator' ? 'selected ' : ''}calculator-select-item
      flex flex-col items-center border-t border-r border-b border-gray-eighty
      py-10 w-1/2 cursor-pointer lg:border-t-0 lg:border-r-0 lg:border-b-0
      lg:border-l lg:w-1/5"
      on:click={() => setActiveCalculator('RefinanceSavingsCalculator')}
      on:keydown={e => setActiveCalculator('RefinanceSavingsCalculator', e)}
      tabindex="0">
      <div class="h-32 lg:h-40">
        <RefinanceSavingsCalculatorIcon {grayIcons} />
      </div>
      <div class="h-24 flex items-center px-10 lg:h-40 lg:px-0">
        <p
          class="text-21 text-center font-medium mt-8 md:text-23 lg:font-light
          lg:mt-8 lg:px-20">
          Refinance Savings
        </p>
      </div>
    </div>
    <div
      class="{activeCalculatorString === 'ReverseMortgageCalculator' ? 'selected ' : ''}calculator-select-item
      flex flex-col items-center border-t border-r border-b border-gray-eighty
      py-10 w-1/2 cursor-pointer lg:border-t-0 lg:border-r-0 lg:border-b-0
      lg:border-l lg:w-1/5"
      on:click={() => setActiveCalculator('ReverseMortgageCalculator')}
      on:keydown={e => setActiveCalculator('ReverseMortgageCalculator', e)}
      tabindex="0">
      <div class="h-32 lg:h-40">
        <ReverseMortgageCalculatorIcon {grayIcons} />
      </div>
      <div class="h-24 flex items-center px-10 lg:h-40 lg:px-0">
        <p
          class="text-21 text-center font-medium mt-8 md:text-23 lg:font-light
          lg:mt-8 lg:px-20">
          Reverse Mortgage 
        </p>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/CalculatorSelect.svelte